import { createServerFn } from "@tanstack/react-start";
import { getRequest, setResponseHeader } from "@tanstack/react-start/server";

export interface VisitorGeo {
  country: string | undefined;
  region: string | undefined;
}

export const getVisitorGeo = createServerFn({ method: "GET" }).handler(
  (): VisitorGeo => {
    // Per-visitor value derived from edge geo headers. It is resolved on the
    // client so public page responses stay request-independent and CDN-cacheable;
    // this RPC itself must never be shared by a CDN/proxy across visitors.
    setResponseHeader("Cache-Control", "private, no-store");
    const { headers } = getRequest();
    return {
      country: headers.get("x-vercel-ip-country") ?? undefined,
      region: headers.get("x-vercel-ip-country-region") ?? undefined,
    };
  }
);
